import sensors from 'sa-sdk-javascript';
import getServerURL from './getServerURL';
import getActType from './getActType';

// window.sensors = sensors //挂载到window

export default (Vue, env, businessType) => {
  console.log(getServerURL(env), 'getServerURL(env)++++');
  sensors.init({
    name: 'sensors',
    is_track_single_page: true, //单页应用自动埋点
    server_url: getServerURL(env, businessType),
    heatmap_url:
      'https://cdn.jsdelivr.net/npm/sa-sdk-javascript@1.13.11/heatmap.min.js',
    heatmap: {
      clickmap: 'not_collect',
      scroll_notice_map: 'not_collect'
    },
    show_log: process.env.NODE_ENV !== 'production'
  });

  sensors.setProfile({
    platForm: 'H5',
    act_type: getActType()
  });

  Vue.prototype.$sensors = sensors;
};
